import React from 'react';
import { Outlet } from 'react-router-dom';
import { AuthGuard } from 'pages/auth-guard';
import Topbar from 'layouts/basic/topbar.component';
import styles from './basic.module.scss';

const BasicLayout = () => {
  return (
    <AuthGuard>
      <>
        <Topbar />
        <div className={styles.basicLayout__wrapper}>
          <Outlet />
        </div>
      </>
    </AuthGuard>
  );
};

export default BasicLayout;
